export default {
  SWAP_PRODUCT: 'SWAP_PRODUCT',
  SWAP_ATC: 'SWAP_ATC',
  SWAP_CART: 'SWAP_CART',
  SWAP_CHECKOUT_SUMMARY: 'SWAP_CHECKOUT_SUMMARY',
  MY_SALES_SHIP_ITEM: 'MY_SALES_SHIP_ITEM',
  MY_SALES_PAYMENT_DETAILS: 'MY_SALES_PAYMENT_DETAILS',
  MY_SALES_COUNTER_OFFER: 'MY_SALES_COUNTER_OFFER',
  MY_SALES_CONFIRM_COUNTER_OFFER: 'MY_SALES_CONFIRM_COUNTER_OFFER',
  REFURBISHER_ORDER_SEND_PAYMENT: 'REFURBISHER_ORDER_SEND_PAYMENT',
  REFURBISHER_ORDER_ON_HOLD: 'REFURBISHER_ORDER_ON_HOLD',
  REFURBISHER_WISHLIST_CSV: 'REFURBISHER_WISHLIST_CSV',
  REFURBISHER_WISHLIST_FILTERS: 'REFURBISHER_WISHLIST_FILTERS',
  REFURBISHER_FILTER_PRODUCTS: 'REFURBISHER_FILTER_PRODUCTS',
  VIEW_COUNTER_OFFER: 'VIEW_COUNTER_OFFER',
  AGENT_UPDATE_CUSTOMER_INFO: 'AGENT_UPDATE_CUSTOMER_INFO',
  AGENT_KYC_ID: 'AGENT_KYC_ID',
  AGENT_KYC_BANK: 'AGENT_KYC_BANK',
  AGENT_KYC_SSN: 'AGENT_KYC_SSN',
  AGENT_PAYMENT: 'AGENT_PAYMENT',
  AGENT_CANCEL_ORDER: 'AGENT_CANCEL_ORDER',
}
